/**
 * Функция для отображения ошибок при обращении к API
 * @param {Object} error
 */
export function onError(error) {
  const defaultError =
    'Ошибка подключения к серверу. Обновите страницу и попробуйте снова.'

  if (error.response && error.response.data) {
    return error.response.data.error_message
  }

  if (error.data) {
    return error.data.error_message
  }

  return error.message || defaultError
}

/**
 * Функции для управления выборкой в списках сущностей
 * @param {Object} e
 */
export function toggleItem(e) {
  const itemID = parseInt(e.target.value),
    { selectedItems } = this.state

  if (selectedItems.has(itemID)) {
    selectedItems.delete(itemID)
  } else {
    selectedItems.add(itemID)
  }
  this.setState({ selectedItems, isAllItemsChecked: false })
}

export function toggleAllItems(filteredItems) {
  const { selectedItems, isAllItemsChecked } = this.state

  if (isAllItemsChecked) {
    selectedItems.clear()
    this.setState({ selectedItems, isAllItemsChecked: false })
  } else {
    filteredItems.forEach(item => {
      selectedItems.add(item.id)
      this.setState({ selectedItems, isAllItemsChecked: true })
    })
  }
}

/**
 * @param {String} modalTitle
 * @param {String} modalText
 */
export function changeVisibillityModalAlert(modalTitle, modalText) {
  this.setState(prevState => ({
    modalTitle,
    modalText,
    isOpenModalAlert: !prevState.isOpenModalAlert,
  }))
}

/**
 * @param {Number} itemsPerPage
 * @param {Number} pageNumber
 * @param {String} searchQuery
 */
export function onChangePagination(itemsPerPage, pageNumber, searchQuery) {
  this.fetchData(itemsPerPage, pageNumber, searchQuery)
  this.setState({ itemsPerPage, pageNumber, searchQuery })
}

/**
 * @param {String} title
 */
export function onChangeSearch(searchQuery) {
  this.setState({ searchQuery })
}
